"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var HorizonLogo = function HorizonLogo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '142' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '53' : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 142 53"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFD971",
    d: "M0 .5h142v52H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M26.058 21.773h1.777v3.863h3.042v-3.863h1.776v9.454h-1.776v-3.89h-3.042v3.89h-1.777v-9.454zm13.735 3.673c0-1.224.307-2.174.922-2.85.614-.675 1.465-1.012 2.55-1.012 1.086 0 1.936.337 2.55 1.013.616.675.923 1.625.923 2.85v2.107c0 1.26-.307 2.22-.922 2.876-.615.658-1.465.986-2.55.986-1.086 0-1.937-.328-2.551-.986-.615-.657-.922-1.616-.922-2.876v-2.108zm3.472 4.35c.323 0 .593-.052.808-.156.215-.103.39-.25.525-.439.134-.189.229-.414.282-.675.054-.261.081-.55.081-.864v-2.324c0-.297-.031-.576-.094-.837a1.93 1.93 0 0 0-.296-.675c-.135-.19-.31-.34-.525-.453a1.667 1.667 0 0 0-.78-.169c-.306 0-.566.057-.781.17-.216.112-.39.263-.525.452a1.93 1.93 0 0 0-.296.675c-.063.261-.095.54-.095.837v2.324c0 .315.027.603.081.864.054.261.148.486.283.675.134.19.31.336.525.44.215.103.484.155.807.155zm17.1 1.431h-1.777v-2.836a.797.797 0 0 0-.168-.527c-.112-.135-.298-.202-.559-.202h-2.045v3.565h-1.777v-9.454h3.607c.485 0 .91.067 1.279.202.368.135.675.322.922.56.246.24.435.516.565.831.13.316.195.653.195 1.013v.325c0 .387-.103.75-.31 1.087-.206.338-.524.596-.955.777v.243c.314.036.563.157.747.364.184.207.276.469.276.784v3.268zm-4.55-5.267h1.696c.431 0 .759-.102.983-.304.224-.203.336-.489.336-.858v-.162a1.13 1.13 0 0 0-.336-.817c-.224-.23-.552-.344-.983-.344h-1.695v2.485zm12.12-4.187h6.3v1.702h-2.262v6.05h2.261v1.702h-6.299v-1.702h2.261v-6.05h-2.261v-1.702zm13.654 0h6.703v2.917l-5.33 4.592v.243h5.491v1.702h-6.945V28.31l5.33-4.592v-.243H81.59v-1.702zm13.842 3.673c0-1.224.308-2.174.922-2.85.615-.675 1.465-1.012 2.55-1.012 1.087 0 1.937.337 2.552 1.013.614.675.922 1.625.922 2.85v2.107c0 1.26-.308 2.22-.922 2.876-.615.658-1.465.986-2.551.986s-1.936-.328-2.55-.986c-.615-.657-.923-1.616-.923-2.876v-2.108zm3.473 4.35c.323 0 .592-.052.807-.156.216-.103.39-.25.525-.439s.23-.414.283-.675c.054-.261.08-.55.08-.864v-2.324c0-.297-.03-.576-.093-.837a1.93 1.93 0 0 0-.296-.675c-.135-.19-.31-.34-.525-.453a1.667 1.667 0 0 0-.781-.169c-.305 0-.565.057-.78.17-.216.112-.391.263-.526.452a1.93 1.93 0 0 0-.296.675c-.063.261-.094.54-.094.837v2.324c0 .315.027.603.08.864.055.261.149.486.283.675.135.19.31.336.525.44.216.103.485.155.808.155zm15.188.54h.243v-8.563h1.776v9.454h-3.472l-1.104-8.563h-.242v8.563h-1.777v-9.454h3.473l1.103 8.563z"
  })));
};

HorizonLogo.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
HorizonLogo.defaultProps = {
  width: '142',
  height: '53'
};
var _default = HorizonLogo;
exports.default = _default;